import classNames from 'classnames';
import { BtnThreeProps } from 'eco-design-micro/props/btn/BtnThreeProps';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import { HorizontalProps } from 'eco-design-micro/props/position/const';
import EcoButtonThree from 'eco-design/base/eco-button-three';
import EcoSection from 'eco-design/base/eco-section';
import React from 'react';
import './index.scss';
export interface EcoSectionCommonProps extends SectionTextWithColorProps, BtnThreeProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 通用段落展示位置
     *
     * left 靠左
     *
     * center 居中
     *
     * right 靠右
     */
    sectionCommonLayout?: HorizontalProps;
}

/**
 *
 * 通用段落
 */
const EcoSectionCommon: React.FC<EcoSectionCommonProps> = ({ className, sectionCommonLayout = 'center', theme, ...reset }) => {
    const prefixCls = `eco-section-common`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-layout-${sectionCommonLayout}`]: sectionCommonLayout,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    return (
        <div className={classes}>
            <EcoSection {...reset} />
            <EcoButtonThree {...reset} layoutBtnThree={sectionCommonLayout} />
        </div>
    );
};

export default EcoSectionCommon;
